import { IControlField2, IFieldResponse } from './control-field.base';

export interface IDateTypeControlField extends IControlField2 {
  default_value?: unknown[];
}

export function toDateTypeField(field: IFieldResponse): IDateTypeControlField {
  const fieldValue: any = field.values;
  let defaultValue: any = null;
  if (fieldValue && fieldValue.start_date) {
    defaultValue = [
      new Date(fieldValue.start_date),
      new Date(fieldValue.end_date)
    ];
  }

  return {
    id: field.id,
    alias: field.alias,
    control_type: field.control_type,
    default_value: defaultValue,
    helper_text: field.helper_text,
    is_active: field.is_active,
    is_disabled: field.is_disabled,
    is_mandatory: field.is_mandatory,
    is_hierarchical: field.is_hierarchical,
    name: field.name,
    placement_order: field.placement_order,
    section: field.section,
    dtype: field.dtype,
    planner_flag: field.planner_flag,
    info_details: field.info_details,
    is_info_enable: field.is_info_enable
  };
}
